import { default as DOMinsertAfter } from '../helpers/dom/insertAfter';
import { nextByClass as DOMnext } from '../helpers/dom/next';
import { findClosestElementByClass as DOMclosestByClass } from '../helpers/dom/closest';
import {scrollToRelativeElement} from "../helpers/dom/scroll";

/**
 * @description Function set active tab on list on Click or using Events on keys
 *
 * @param {HTMLElement} event
 * @param {HTMLElement} eventCurrentTarget
 * @param {Function} filterContent
 * @returns {HTMLElement} "event.currentTarget" from params
 */
function _setActiveTab (event, eventCurrentTarget, filterContent) {
	if (event.currentTarget !== eventCurrentTarget) {
		const tabDataValue = event.currentTarget.getAttribute('data-tab');
		filterContent && filterContent(tabDataValue);

        eventCurrentTarget = event.currentTarget;
        const parentSimulator = DOMclosestByClass(eventCurrentTarget, "pricing-simulator");
        if (parentSimulator) {
            const longListContainer = parentSimulator.querySelector(".pricing-simulator__long-list");
            const longListElement = parentSimulator.querySelector('[data-long-name]:not(.is-hidden)');
            // console.log('longListElement', longListElement);
            if (longListElement) {
                scrollToRelativeElement(longListContainer, longListElement);
            }	
        }
	}
	return eventCurrentTarget;
}

/**
 * @classdesc Tabs filters for list of items
 * @example How to use it
 * 
 * TODO: example of html?
 * 
 * @class TabsFilters
 * @todo Logic for filter content in tabs should be refactor (look at TODOs)
 */
class TabsFilters {
	/**
	 * @param {Object} props
	 * @param {HTMLElement} [props.root=document] ex. 'document.querySelector('#app')
	 * @param {String} [props.Id='tv-packages'] class name, ex. 'tv-packages'; There is without dot!
	 * @param {InstanceClass} [props.IncomingInstanceOfComponent=null] ex. new PacketsTv()
	 * @
	 * @memberof PacketsTv
	 */
	constructor (props) {
		this.$root = props.$root || document;
		this.Id = props.Id || 'tv-packages';
		this.IncomingInstanceOfComponent = props.IncomingInstanceOfComponent || null;
		this.AllTvPacketsIsHidden = false;

		this.$tabsFiltersItems = Array.from(this.$root.querySelectorAll(`[data-tabsAction-module=${this.Id}] [data-tab]`)); // TODO: zmiana atrybytu data-tab na inny, poniewaz jest konflikt z logiką komponentu tab.js 
	}

	/**
	 *
	 *
	 * @memberof TabsFilters
	 */
	init() {
		this.checkCategory();
	}

	/**
	 *
	 *
	 * @memberof TabsFilters
	 */
	checkCategory () {
		if (this.$tabsFiltersItems.length > 0) {
			// On start - first tab
			this.filterContent();
	
			let eventCurrentTarget = null;
			this.$tabsFiltersItems.forEach(tab => {
				tab.addEventListener('click', (event) => {
					eventCurrentTarget = _setActiveTab(event, eventCurrentTarget, this.filterContent.bind(this));
				});
				tab.addEventListener('keypress', (event) => {
					if (event.keyCode === 0 || event.keyCode === 32 || event.keyCode === 13) {
						eventCurrentTarget = _setActiveTab(event, eventCurrentTarget, this.filterContent.bind(this));
					}
				})
			})
		}
	}
	/**
	 *
	 *
	 * @param {string} [tabDataValue='']
	 * @memberof TabsFilters
	 */
	filterContent (tabDataValue = '') {
		const packagesArr = [...this.$root.querySelectorAll('.' + this.Id)];
		const $wrapperTvPackets = this.$root.querySelector(this.IncomingInstanceOfComponent.idElementParent);
 
		if (packagesArr.length > 0) {
			if (tabDataValue.length > 0 && tabDataValue !== '0') {
				packagesArr.forEach(el => {
					const elementClosest = DOMclosestByClass(el, 'placeholder');
					const packageDataValue = elementClosest.getAttribute('data-category');
	
					if (packageDataValue && packageDataValue.includes(tabDataValue)) {
						elementClosest.classList.remove('is-hidden');
					} else {
						if (!elementClosest.classList.contains('action-tab__message')) {
							elementClosest.classList.add('is-hidden');
						}
					}
				});
			} else if (tabDataValue === null || tabDataValue === '0') {
				packagesArr.forEach(el => {
					const elementClosest = DOMclosestByClass(el, 'placeholder');
					elementClosest.classList.remove('is-hidden');
				});
			}
 
			// Set TRUE if all tv packets are hidden
			this.AllTvPacketsIsHidden = packagesArr.every(el => {
				const elementClosest = DOMclosestByClass(el, 'placeholder');
				return elementClosest.classList.contains('is-hidden');
			});


			if ($wrapperTvPackets) {
				const $wrapperTvPacketsNextElem = DOMnext($wrapperTvPackets, 'action-tab__message');
				if ($wrapperTvPacketsNextElem) {
					$wrapperTvPacketsNextElem.remove();
				}
			}
	
			// TODO: komunikat z informacją o braku pakietów w aktywnej kategorii wyrzucić na zewnątrz
			if (this.AllTvPacketsIsHidden) {
				if ($wrapperTvPackets) {
					let $messageAllPacketsIsHidden = document.createElement('div');
					$messageAllPacketsIsHidden.className = "placeholder placeholder--b2c-gray placeholder--noPaddingBottom action-tab__message"; // TODO: it should be define in settings Class
					$messageAllPacketsIsHidden.innerHTML = `
						<div class="container">
							<div class="tv-packages"><p>Brak pakietów w tej kategorii.</p></div>
						</div>
					`;
					DOMinsertAfter($messageAllPacketsIsHidden, $wrapperTvPackets);
				}
			}
	
			
			if (this.IncomingInstanceOfComponent) {
				this.IncomingInstanceOfComponent.init();
				// console.log('PacketsTv.shownAllElements => filter', this.IncomingInstanceOfComponent.shownAllElements);
			}
		}
	}
}

export default TabsFilters;
